export default __webpack_public_path__ + "static/heroMockupContent-f83d8c07601a93c06f722197a25d2459.png";